import { Component, OnInit, Input } from '@angular/core';

declare var $: any //jquery

type DataTable = {
  paging: boolean;
  ordering: boolean;
  searching: boolean;
  showNEntries: boolean;
  responsive: boolean;
  select: boolean;
  autoWidth: boolean;
  oLanguage:object;
}


@Component({
  selector: 'ng-table',
  templateUrl: './table.component.html'
})

export class TableComponent implements OnInit {

  @Input() public dataTableOptions:DataTable;//optional

  @Input() public tableHeaderAndFooterColumns:Array<string> //header and footer attributes

  constructor(){

    this.tableHeaderAndFooterColumns=new Array<string>();

    this.dataTableOptions={
      paging:true,
      ordering:true,
      searching:true,
      showNEntries:true,
      responsive:true,
      select:true,
      autoWidth:true,
      info:true,
      oLanguage: {
        sEmptyTable: "Nehum dado disponível na tabela!"
      },
    } as DataTable
    
  }
  
  ngOnInit() {
    this.initTable()
  }
  
  initTable() {
    
    setTimeout(() => {

      $('#abstractTable').DataTable(this.dataTableOptions);

    }, 50);

  }

}
